<div [class]="wrapperClass + ' salutation-wrapper'">
    <div class="row column">
        <label class="nomargin" [class.error]="formElement?.invalid === true && formElement?.touched === true"
            [innerHtml]="formElement?.invalid === true && formElement?.touched === true ? ('contact.salutation.label.error' | translate) : ('contact.salutation.label' | translate) + (isSalutationMandatory()? '' : ('contact.optional' | translate))"></label>
    </div>
    <div class="radio-wrapper">
				<radio [(model)]="contact.data.salutation" [value]="'female'" [name]="'salutation'"
						[label]="'contact.salution.female.label' | translate" [class]="'with-textfield'" [form]="form"></radio>

				<radio [(model)]="contact.data.salutation" [value]="'male'" [name]="'salutation'"
						[label]="'contact.salution.male.label' | translate" [class]="'with-textfield'" [form]="form"></radio>

				<radio [(model)]="contact.data.salutation" [value]="'divers'" [name]="'salutation'" *ngIf="hasSalutationDivers"
						[label]="'contact.salution.divers.label' | translate" [class]="'with-textfield'" [form]="form"></radio>

				<radio [(model)]="contact.data.salutation" [value]="salutationOtherValue" [name]="'salutation'" *ngIf="hasSalutationOther"
						[label]="'contact.salutation.other.label' | translate" [class]="'with-textfield'" [form]="form"></radio>
    </div>
</div>
